export enum HttpMethod {
  GET = 'get',
  POST = 'post',
  PUT = 'put',
  DEL = 'del',
  PATCH = 'patch',
}
